var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScoreplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 1162.07 179.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.93,44.09c7.03-12.18,2.86-27.74-9.32-34.77h0C29.44,2.29,13.87,6.46,6.84,18.63h0C-7.23,43,1.11,74.13,25.47,88.19h0c1.93,1.12,3.91,2.09,5.92,2.93.07-8.5,2.27-17.11,6.82-25l12.72-22.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.4,54.31h0c-1.93-1.12-3.91-2.09-5.92-2.93-.07,8.5-2.27,17.11-6.82,25l-12.72,22.03c-7.03,12.18-2.86,27.74,9.32,34.77h0c12.18,7.03,27.74,2.86,34.77-9.32h0c14.06-24.36,5.72-55.5-18.64-69.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.02,6.83h0c-24.35-14.06-55.49-5.72-69.55,18.64l-25.46,44.09c-12.94,22.42-40.36,31.27-63.63,21.56-.14,17.74,9,35.05,25.46,44.55,24.35,14.06,55.49,5.72,69.55-18.64l25.46-44.09c12.94-22.42,40.36-31.27,63.63-21.56.14-17.74-9-35.05-25.46-44.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.53,96.72h26.4c1.4,12.8,10.2,22.2,25.4,22.2,12,0,21.4-6.6,21.4-16,0-28.2-70.99-13-70.99-62.2,0-21.8,17.8-39.4,46.4-39.4,32,0,47.2,22.4,48,42.8h-26.4c-.8-10.8-8.4-20-21.6-20s-20.8,7.2-20.8,16.6c0,26.6,70.99,11,70.99,62.2,0,23.2-22.8,39-47,39-36.2,0-51.2-25.6-51.8-45.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.93,92.72c0-28.2,21-49,49.6-49,24.4,0,42.4,14.6,46.2,36.2h-24.6c-3.6-9-10.8-14-21-14-14.6,0-25.2,11-25.2,26.8s10.6,27,25.2,27c10.2,0,17.2-5,21-14.2h24.6c-3.8,21.6-21.8,36.4-46.2,36.4-28.6,0-49.6-21-49.6-49.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553.92,92.72c0-27.8,21-49,50.2-49s50.2,21.2,50.2,49-21,49.2-50.2,49.2-50.2-21.4-50.2-49.2ZM629.31,92.72c0-15.8-10.6-27-25.2-27s-25.2,11.2-25.2,27,10.6,27,25.2,27,25.2-11,25.2-27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M662.51,139.72v-55.4c0-22.6,13.2-40.6,39.6-40.6,4.8,0,8.4.4,12.6,1.4v22.8c-3-.2-5.6-.2-6.8-.2-14,0-20,6.4-20,19.4v52.6h-25.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M812.1,101.32h-70.99c3,12.8,12,19.6,24.2,19.6,11,0,17.2-3,21-9.6h23.4c-5.8,20.8-24.8,30.6-43.8,30.6-29.2,0-48.8-20.8-48.8-49.2s20-49,48.2-49,47.2,21,47.2,49c0,3.6,0,5-.4,8.6ZM740.9,83.72h47.8c-1.6-11-11.2-19-23.4-19s-21.6,7.6-24.4,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M925.89,46.32c0,28-20.8,43.2-45.6,43.2h-30.4v50.2h-25.6V3.32h56c24.8,0,45.6,15,45.6,43ZM876.29,65.32c14.2,0,23.6-6.8,23.6-19s-9.4-18.8-23.4-18.8h-26.6v37.8h26.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M934.49,139.72V3.32h25.2v136.4h-25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1067.28,92.92v46.8h-22.4l-1.6-14c-6,10.2-16.8,16.2-30.4,16.2-24.6,0-45-19.6-45-49.2,0-28,21.2-49,49.8-49s49.6,18.8,49.6,49.2ZM1042.28,92.72c0-16.4-10.8-27-24.6-27s-24.8,11-24.8,27,10.6,27,24.8,27c12.2,0,24.6-8.6,24.6-27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1134.47,45.72h27.6l-51.4,133.6h-28.2l17.2-39.4-36.6-94.2h28.2l17.8,53.8c1.8,5.2,2.8,10,3.6,15.8h.4c.8-5.8,2-10.6,3.6-15.8l17.8-53.8Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreplay);
export default __webpack_public_path__ + "static/media/scoreplay.9e85faa9c1c03498443bed8f637cfccc.svg";
export { ForwardRef as ReactComponent };